"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var filter_dto_builder_1 = require("./filter-dto-builder");
var measure_range_filter_dto_1 = require("../dto/measure-range-filter-dto");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var exact_filter_dto_1 = require("../dto/exact-filter-dto");
var contains_filter_dto_1 = require("../dto/contains-filter-dto");
var starts_with_filter_dto_1 = require("../dto/starts-with-filter-dto");
var ends_with_filter_dto_1 = require("../dto/ends-with-filter-dto");
var is_specific_day_filter_dto_1 = require("../dto/is-specific-day-filter-dto");
/**
 * Created by Hayk.Andriasyan on 5/25/2017.
 */
var MeasureItem = /** @class */ (function () {
    function MeasureItem(parentOperator, measurePathHolderId) {
        this.isExcluded = false;
        this.isHidden = false;
        this.parentOperator = parentOperator;
        this.measurePathHolderId = measurePathHolderId;
    }
    MeasureItem._formatDate = function (date) {
        var day = ('0' + date.getDate()).slice(-2);
        var month = ('0' + (date.getMonth() + 1)).slice(-2);
        var year = date.getFullYear();
        return year + "-" + month + "-" + day;
    };
    MeasureItem.prototype.addFilterToParentOperator = function () {
        this.parentOperator.addFilter(this.getFilter());
    };
    MeasureItem.prototype.getFilter = function () {
        this.filter.excluded = this.isExcluded;
        this.filter.isHiddenForUser = this.isHidden;
        return this.filter;
    };
    MeasureItem.prototype.is = function (value, currencyId, byCategoryPathHolderId) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(value);
        var filterValue;
        var filterCurrencyId = null;
        var filterByCategoryPathHolderId = null;
        switch (typeof value) {
            case 'string':
                filterValue = value;
                break;
            case 'object':
                if (value instanceof Date) {
                    filterValue = MeasureItem._formatDate(value);
                }
                break;
            case 'number':
                filterValue = value.toString();
                break;
        }
        if (typeof currencyId === 'number') {
            filterCurrencyId = currencyId;
        }
        if (typeof byCategoryPathHolderId !== 'undefined') {
            filterByCategoryPathHolderId = byCategoryPathHolderId;
        }
        var filter = new exact_filter_dto_1.ExactFilterDto(this.measurePathHolderId, filterValue, filterCurrencyId, filterByCategoryPathHolderId);
        return this._getParentOperator(filter);
    };
    /* tslint:enable:unified-signatures */
    MeasureItem.prototype.isSpecificDay = function (value) {
        var filter = new is_specific_day_filter_dto_1.IsSpecificDayFilterDto(this.measurePathHolderId, value);
        return this._getParentOperator(filter);
    };
    MeasureItem.prototype.contains = function (pattern) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(pattern);
        var filter = new contains_filter_dto_1.ContainsFilterDto(this.measurePathHolderId, pattern);
        return this._getParentOperator(filter);
    };
    MeasureItem.prototype.startsWith = function (prefix) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(prefix);
        var filter = new starts_with_filter_dto_1.StartsWithFilterDto(this.measurePathHolderId, prefix);
        return this._getParentOperator(filter);
    };
    MeasureItem.prototype.endsWith = function (suffix) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(suffix);
        var filter = new ends_with_filter_dto_1.EndsWithFilterDto(this.measurePathHolderId, suffix);
        return this._getParentOperator(filter);
    };
    MeasureItem.prototype.between = function (from, to, currencyId, byCategoryPathHolderId) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(from);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(to);
        var inclusive = true;
        var filterType = '';
        var valueFrom = '';
        var valueTo = '';
        var filterCurrencyId = null;
        var filterByCategoryPathHolderId = null;
        if (typeof from === 'number') {
            filterType = filter_dto_builder_1.FilterDtoBuilder.BETWEEN;
            valueFrom = from.toString();
            valueTo = to.toString();
        }
        else {
            filterType = filter_dto_builder_1.FilterDtoBuilder.BETWEEN_DATES;
            valueFrom = MeasureItem._formatDate(from);
            valueTo = MeasureItem._formatDate(to);
        }
        if (typeof currencyId === 'number') {
            filterCurrencyId = currencyId;
        }
        if (typeof byCategoryPathHolderId === 'number') {
            filterByCategoryPathHolderId = byCategoryPathHolderId;
        }
        var filter = new measure_range_filter_dto_1.MeasureRangeFilterDto(filterType, this.measurePathHolderId, valueFrom, valueTo, inclusive, filterCurrencyId, filterByCategoryPathHolderId);
        return this._getParentOperator(filter);
    };
    /* tslint:enable:unified-signatures */
    MeasureItem.prototype.lessThan = function (value, currencyId, byCategoryPathHolderId) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(value);
        return this._comparingFilter(filter_dto_builder_1.FilterDtoBuilder.LESS_THAN, false, null, value.toString(), currencyId, byCategoryPathHolderId);
    };
    MeasureItem.prototype.lessThanOrEqual = function (value, currencyId, byCategoryPathHolderId) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(value);
        return this._comparingFilter(filter_dto_builder_1.FilterDtoBuilder.LESS_THAN_OR_EQUAL, true, null, value.toString(), currencyId, byCategoryPathHolderId);
    };
    MeasureItem.prototype.greaterThan = function (value, currencyId, byCategoryPathHolderId) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(value);
        return this._comparingFilter(filter_dto_builder_1.FilterDtoBuilder.GREATER_THAN, false, value.toString(), null, currencyId, byCategoryPathHolderId);
    };
    MeasureItem.prototype.greaterThanOrEqual = function (value, currencyId, byCategoryPathHolderId) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(value);
        return this._comparingFilter(filter_dto_builder_1.FilterDtoBuilder.GREATER_THAN_OR_EQUAL, true, value.toString(), null, currencyId, byCategoryPathHolderId);
    };
    MeasureItem.prototype.before = function (start) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(start);
        var filter = new measure_range_filter_dto_1.MeasureRangeFilterDto(filter_dto_builder_1.FilterDtoBuilder.BEFORE, this.measurePathHolderId, null, MeasureItem._formatDate(start), false, null, null);
        return this._getParentOperator(filter);
    };
    MeasureItem.prototype.after = function (end) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(end);
        var filter = new measure_range_filter_dto_1.MeasureRangeFilterDto(filter_dto_builder_1.FilterDtoBuilder.AFTER, this.measurePathHolderId, MeasureItem._formatDate(end), null, false, null, null);
        return this._getParentOperator(filter);
    };
    MeasureItem.prototype.onOrBefore = function (start) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(start);
        var filter = new measure_range_filter_dto_1.MeasureRangeFilterDto(filter_dto_builder_1.FilterDtoBuilder.ON_OR_BEFORE, this.measurePathHolderId, null, MeasureItem._formatDate(start), true, null, null);
        return this._getParentOperator(filter);
    };
    MeasureItem.prototype.onOrAfter = function (end) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(end);
        var filter = new measure_range_filter_dto_1.MeasureRangeFilterDto(filter_dto_builder_1.FilterDtoBuilder.ON_OR_AFTER, this.measurePathHolderId, MeasureItem._formatDate(end), null, true, null, null);
        return this._getParentOperator(filter);
    };
    MeasureItem.prototype.not = function () {
        this.isExcluded = !this.isExcluded;
        return this;
    };
    MeasureItem.prototype.isHiddenFromUser = function (isHidden) {
        this.isHidden = isHidden;
        return this;
    };
    MeasureItem.prototype._getParentOperator = function (filter) {
        this.filter = filter;
        this.addFilterToParentOperator();
        return this.parentOperator;
    };
    MeasureItem.prototype._comparingFilter = function (filterType, inclusive, valueFrom, valueTo, currencyId, byCategoryPathHolderId) {
        var filterCurrencyId = null;
        var filterByCategoryPathHolderId = null;
        if (typeof currencyId !== 'undefined') {
            filterCurrencyId = currencyId;
        }
        if (typeof byCategoryPathHolderId !== 'undefined') {
            filterByCategoryPathHolderId = byCategoryPathHolderId;
        }
        var filter = new measure_range_filter_dto_1.MeasureRangeFilterDto(filterType, this.measurePathHolderId, valueFrom, valueTo, inclusive, filterCurrencyId, filterByCategoryPathHolderId);
        return this._getParentOperator(filter);
    };
    return MeasureItem;
}());
exports.MeasureItem = MeasureItem;
//# sourceMappingURL=measure-item.js.map